/*
 * @Author: hujingyang
 * @Description: 重构Header
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from "react";
import { Badge, Balloon, Button, Icon, Message, Tab } from "@alifd/next";
import style from "./index.module.scss";
import { appHistory } from "@ice/stark-app";
import Icon_remind from "@/assets/icon/icon-remind.svg";
import vipIcon from "@/assets/vip.png";
import Icon_triangle from "@/assets/icon/icon-triangle.svg";
import { event, store } from "@ice/stark-data";
import utils from "@/common/utils";
import { Servlets } from "@/service";
import BindTelPhone from "@/components/BindTelPhone";

/** 顶部Header组件 */
const Header = (): JSX.Element => {
  const [storeInfo, setStoreInfo] = useState({
    phone: "",
    remainingDay: 0,
    shopName: "",
    smsTotal: 0,
  }); // 店铺信息
  const [bindingPhone, setBindingPhone] = useState(false); // 手机绑定状态

  const [messageNotice_update, setMessageNotice_update] = useState([{ id: "", title: "", detail: "" }]); // 消息提醒_更新
  const [messageNotice_bulletin, setMessageNotice_bulletin] = useState([{ id: "", title: "", detail: "" }]); // 消息提醒_公告

  const [visibleBindingPhone, setVisibleBindingPhone] = useState(false); // 当前手机绑定弹窗是否打开

  const [currentBalance, setCurrentBalance] = useState(0); // 商家当前短信余额

  const [visibleDialog, setVisibleDialog] = useState(false); // 是否打开绑定手机号弹窗

  useEffect(() => {
    init();
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    getPageData();

    getStoreInfo();

    // 薛定谔的手机绑定状态
    // setBindingPhone(!!Math.floor(Math.random() * 2))
  };

  /**  获取数据 */
  const getPageData = (): void => {
    setMessageNotice_update(getMessageNotice());

    setMessageNotice_bulletin(getMessageNotice());
  };

  /** 获取店铺基本信息 */
  const getStoreInfo = (): void => {
    Servlets("getTitle")
      .then((res: { data: { phone: ""; remainingDay: 0; shopName: ""; smsTotal: 0 } }) => {
        if (!res.data.shopId) {
          setStoreInfo({
            phone: "",
            remainingDay: 0,
            shopName: "",
            smsTotal: 0,
          });
          return;
        }

        const phone = res.data.phone?.split("");
        phone?.splice(3, 0, " ");
        phone?.splice(8, 0, " ");

        setStoreInfo({ ...res.data, ...{ phone: phone?.join("") } }); // 店铺信息
        setBindingPhone(!!res.data.phone); // 店铺是否已绑定手机号
        setCurrentBalance(res.data.smsTotal); // 保存店铺剩余短信数

        store.set("remainingDay", res.data.remainingDay);
        window.sessionStorage.setItem('shopName', res.data.shopName);
      })
      .catch((err) => {
        console.log(err);
        setStoreInfo({ phone: "", remainingDay: 0, shopName: "", smsTotal: 0 });
      });
  };

  /** 获取消息提醒信息 */
  const getMessageNotice = (): Array<{
    id: string;
    title: string;
    detail: string;
  }> => {
    const message = [{ id: "", title: "", detail: "" }];

    for (let index = 0; index < 10; index++) {
      message.push({
        id: "1001",
        title: "超级营销开卡渠道标签上线",
        detail: "超级营销开卡渠道标签上线超级营销开卡渠道标签上线超级营销开卡渠道标签上线超级营销开卡渠道标签上线",
      });
    }

    message.shift();
    return message;
  };

  /** 路由重导向 */
  const pageRedirect = (url: string): void => {
    console.log(url);
    appHistory.push(url);
  };

  /** 递归拆解 面包屑对象 拼装为数组 */
  const getBreadcrumbArr = (params: { name: string; url: string; children: any }, currentBreadcrumbArr: any): [{ name: string; url: string }] => {
    currentBreadcrumbArr.push({ name: params.name, url: params.url });
    return params.children ? getBreadcrumbArr(params.children, currentBreadcrumbArr) : currentBreadcrumbArr;
  };

  /** header Balloon 悬浮窗显示/隐藏状态切换改变时触发 */
  const handleHeaderBalloonChange = (visible: boolean): void => {
    setVisibleBindingPhone(visible);
    getStoreInfo();
  };

  const handleOpenChangeBindTelDialog = (): void => {
    setVisibleDialog(true);
  };

  /** 监听 PageCurrent Tabs */
  event.on("currentTab", (props) => {
    store.set("currentTab", props);
  });

  /** 监听 PageCurrent child Tabs */
  event.on("currentTab_child", (props) => {
    store.set("currentTab_child", props);
  });

  /** 获取短信余额 */
  const getPaymentRecord = (isReFresh = false) => {
    Servlets("getPageSmsNum").then((res: { data: number }) => {
      if (res.data === undefined) {
        return;
      }

      setCurrentBalance(res.data);

      if (isReFresh) Message.success("余额已刷新");
    });
  };

  /** 立即充值 */
  const immediatelyPrepaid = () => {
    store.set("currentTab", "SMSPayment");

    // 页面跳转新建短信营销页面
    appHistory.push("/web/accountKeeper");
  };
  /** 刷新余额 */
  const refreshPrepaid = () => {
    getPaymentRecord(true);
  };

  /** 函数防抖 响应函数 */
  const responseFunc = (func, ...argu) => {
    utils.debounceImmediately(func)(argu); // 立即执行
  };

  return (
    <>
      <div attr-intro="快捷操作" className={style.quickActions}>
        <div>
          <Balloon
            className={style['header-customer-service-balloon']}
            v2
            trigger={
              <img
                src="//img14.360buyimg.com/cms/jfs/t1/339055/28/1507/5932/68ac29d3F733e80d0/eccb2129d44d693d.png"
                alt=""
                style={{ cursor: 'pointer', width: '20px', height: '20px' }}
              />
            }
            align="b"
            triggerType="hover"
            closable={false}
          >
            <div
              style={{
                textAlign: 'center'
              }}
            >
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  marginBottom: '10px'
                }}
              >
                微信扫码 联系客服
              </div>
              <img width={100} height={100} src="//img14.360buyimg.com/cms/jfs/t1/324025/9/10863/6899/68ac29edF3bfb39ef/43e96e0e15199b0c.png" alt="云鹿·咨询" />
            </div>
          </Balloon>
        </div>
        <div attr-intro="剩余天数" className={style.item}>
          <span>剩余天数：{storeInfo.remainingDay}</span>&nbsp;&nbsp;
          {/*<Button className={style.button} type="secondary" size="small">*/}
          {/*  续费*/}
          {/*</Button>*/}
          <a href="https://fuwu.jinritemai.com/detail?service_id=19714" target="_blank">
            <Button className={style.button} type="secondary" size="small">
              续费
            </Button>
          </a>
        </div>
        <div attr-intro="剩余短信" className={style.item}>
          <span>剩余短信：{currentBalance}</span>&nbsp;&nbsp;
          <Button type="primary" size="small" text onClick={() => responseFunc(refreshPrepaid)}>
            刷新
          </Button>
          &nbsp;&nbsp;
          <Button className={style.button} type="secondary" size="small" onClick={immediatelyPrepaid}>
            充值
          </Button>
        </div>
        <div attr-intro="店铺快捷功能" className={style.item}>
          <Balloon
            popupClassName="newHeaderBallon"
            trigger={
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span>{storeInfo.shopName}</span>&nbsp;&nbsp;
                {/* style={{ minWidth: 80 }} visible={true} visibleBindingPhone 店铺快捷功能展开/关闭图标 */}
                <img
                  src={Icon_triangle}
                  style={{
                    width: 14,
                    height: 14,
                    transition: "transform .5s",
                    transform: `${visibleBindingPhone ? "rotate(180deg)" : "rotate(0deg)"}`,
                  }}
                  alt="店铺快捷功能展开/关闭图标"
                />
              </div>
            }
            triggerType="hover"
            closable={false}
            // align={storeInfo.shopName?.length >= 8 ? "b" : "bl"}
            align='bl'
            offset={[0, 0]}
            onVisibleChange={handleHeaderBalloonChange}
          >
            <div attr-intro="店铺快捷操作悬浮窗" className="storeQuickOperation">
              <div attr-intro="店铺名称" className="storeName">
                {/* <span>太平鸟</span> */}
                {/* <span>抖音官方旗舰店</span> */}
                <span style={{ textAlign: "center", padding: "0 12px" }}>{storeInfo.shopName}</span>
                <img alt="店铺等级图标" src={vipIcon} style={{ marginTop: "12px" }} />
              </div>
              <div attr-intro="绑定手机号" className="storeConnectTel">
                <div className="tel">
                  {/* 180 0880 0880 */}
                  {bindingPhone ? (
                    <div className="unbound">
                      <span className="bindingTel">{storeInfo.phone}</span>
                    </div>
                  ) : (
                    <div className="unbound">
                      <Icon type="prompt" size="small" style={{ color: "#f0b447", marginRight: 8 }} />
                      <span>手机号未绑定</span>
                    </div>
                  )}
                </div>
                <div className="btn">
                  <div className="bindText">{bindingPhone ? "手机号已绑定" : ""}</div>
                  <Button type="primary" className="funcBtn" onClick={handleOpenChangeBindTelDialog}>
                    {bindingPhone ? "更改绑定" : "立即绑定"}
                  </Button>
                </div>
              </div>
              {/* <div attr-intro="退出" className="storeLogout">
                <Button type="primary" text>
                  退出 <Icon type="exit" />
                </Button>
              </div> */}
            </div>
          </Balloon>
        </div>

        {false && (
          <div attr-intro="消息提醒" style={{ cursor: "pointer" }}>
            <Balloon
              popupClassName="newHeaderBallon"
              popupStyle={{ borderColor: "#FFF", padding: 12 }}
              trigger={
                <Badge count={35}>
                  <img src={Icon_remind} alt="消息提醒图标" style={{ width: 24, height: 24 }} />
                </Badge>
              }
              triggerType="hover"
              closable={false}
              align="bl"
              offset={[0, -10]}
            >
              <div attr-intro="消息提醒快捷操作悬浮窗" className="storeQuickOperation">
                <Tab size="small">
                  <Tab.Item title="更新">
                    <div className="messageNotice">
                      <ul>
                        {messageNotice_update.map((item, index) => {
                          return (
                            <li className="messageList" key={index}>
                              <div attr-intro="动态高亮点" className="dot">
                                <span className="dot-animate" />
                              </div>
                              <Balloon
                                popupClassName="newHeaderBallon secondBallon"
                                popupStyle={{
                                  borderColor: "#FFF",
                                  padding: 12,
                                }}
                                trigger={<p>{item.title}</p>}
                                triggerType="click"
                                closable={false}
                                align="lt"
                                offset={[-28, 30]}
                              >
                                <div className="noticeDetail">{item.detail}</div>
                              </Balloon>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </Tab.Item>

                  <Tab.Item title="公告">
                    <div className="messageNotice">
                      {messageNotice_bulletin.map((item, index) => {
                        return (
                          <li className="messageList" key={index}>
                            <div attr-intro="动态高亮点" className="dot">
                              <span className="dot-animate" />
                            </div>

                            <Balloon
                              popupClassName="newHeaderBallon secondBallon"
                              popupStyle={{ borderColor: "#FFF", padding: 12 }}
                              trigger={<p>{item.title}</p>}
                              triggerType="click"
                              closable={false}
                              align="lt"
                              offset={[-28, 30]}
                            >
                              <div className="noticeDetail">{item.detail}</div>
                            </Balloon>
                          </li>
                        );
                      })}
                    </div>
                  </Tab.Item>
                </Tab>
              </div>
            </Balloon>
          </div>
        )}
      </div>
      <BindTelPhone
        visible={visibleDialog}
        selected={(visibleDialog: boolean) => {
          setVisibleDialog(visibleDialog);
        }}
        bindingPhone={bindingPhone}
        defaultPhone={storeInfo.phone?.replace(/\s/g,'') ||''}
      />
    </>
  );
};

export default Header;

